/**
 * Mutable state container for view-related streaming state.
 * Passed by reference to allow functions to update closure variables.
 */

export interface StreamingViewState {
	/** Whether streaming has been activated in this view lifecycle */
	hasActivatedStreaming: boolean;
	/** Timeout ID for loading animation */
	loadingTimeout: number | undefined;
	/** Original outline of editor content area (for restoration) */
	originalOutline: string | undefined;
	/** Original outline color of editor content area (for restoration) */
	originalOutlineColor: string | undefined;
	/** Original tabIndex of editor content area (for restoration) */
	originalTabIndex: number | undefined;
}

/**
 * Creates initial streaming view state.
 */
export function createStreamingViewState(): StreamingViewState {
	return {
		loadingTimeout: undefined,
		originalTabIndex: undefined,
		originalOutlineColor: undefined,
		originalOutline: undefined,
		hasActivatedStreaming: false,
	};
}
